/** Chybové kódy lookupu 1:1 s legacy data.php + klientské multiple_invoices */
export type LookupErrorCode =
    | 'no_order_number'
    | 'no_email'
    | 'wrong_doc_number'
    | 'order_not_found'
    | 'order_not_invoiced'
    | 'wrong_email'
    | 'ordered_with_email'
    | 'multiple_invoices'
    | 'invalid_items'
    | 'invalid_invoice';

export interface Objednavka {
    cislo_objednavky: string;
    cislo_faktury: string;
    forma_uhrady: string;
    zpusob_dopravy: string;
    fa_ico: string;
    fa_dic: string;
    datum_vystaveni_faktury: string;
    dni_od_data_vystaveni_faktury: number;
    obj_telefon: string;
    nazev_odb: string;
    par_tel: string;
    par_mobil: string;
    cislo_uctu: string;
    kod_banky: string;
    iban: string;
    jmeno_banky: string;
    shop_country_code: string;
    invoice_source?: 'flexi' | 'premier' | null;
}

export interface VratkaItem {
    product_name: string;
    product_code: string;
    amount: number;
}

/** Vybraná položka – amount je string kvůli kontrolovanému inputu (prázdný = nezadáno) */
export interface ReturnedItem {
    product_name: string;
    product_code: string;
    amount: number | string;
}

export interface LookupData {
    objednavka: Objednavka;
    typ: 'order' | 'invoice';
    polozky: VratkaItem[];
    faktury: { cislo_faktury: string }[];
}

export type LookupResult = LookupData | { error_message: LookupErrorCode };

export type TypVraceni = 'vratka' | 'reklamace';

export type Page = 'init' | 'baseInput' | 'product_selector' | 'form' | 'contact' | 'summary' | 'finished';

export interface UserInput {
    duvod_vraceni: string;
    duvod_vraceni_detail: string;
    cislo_uctu_user: string;
    iban_user: string;
    vracene_polozky: ReturnedItem[];
    user_cislo_dokladu: string;
    user_email: string;
    no_order_email: boolean;
    no_account_number: boolean;
    contact_phone: string;
    contact_name: string;
    contact_email: string;
    has_special_conditions: boolean;
    special_conditions: string;
}

export interface CreateReturnPayload {
    cislo_dokladu: string;
    email: string;
    no_order_email: boolean;
    typ: TypVraceni;
    cislo_faktury: string;
    duvod_vraceni: string;
    duvod_vraceni_detail: string;
    cislo_uctu_user: string;
    iban: string;
    special_conditions: string;
    contact_name: string;
    contact_phone: string;
    contact_email: string;
    items: { product_code: string; product_name: string; amount: number }[];
}

export type CreateReturnResult = { stitek_info: string } | { error_message: LookupErrorCode };

/** Nápověda e-mailů k dokladu – prázdný řetězec = e-mail není známý */
export interface SuggestedEmails {
    obj_email: string;
    par_email: string;
    par_email_login: string;
}

export interface VratkyAppProps {
    apiBaseUrl: string;
    translationsUrl: string | null;
    language: string;
    /** nápověda e-mailů k dokladu – server ji povoluje jen obsluze */
    emailHints?: boolean;
}

export function isLookupError<T>(
    result: T | { error_message: LookupErrorCode },
): result is { error_message: LookupErrorCode } {
    return typeof (result as { error_message?: unknown }).error_message === 'string';
}
